import expensize from '@sdk/helpers/formatters/expensize';

const DEFAULT = 'Taxas do financiamento';

function description(expense) {
  if (expense.payload && expense.payload.description) {
    return expense.payload.description;
  }

  if (expense.description) {
    return expense.description;
  }

  return DEFAULT;
}

function codes(expense, code) {
  switch (code) {
    case '8':
    case 'contract_record_rate':
      return 'Tarifa de registro do contrato';
    case '6':
    case 'register_rate':
      return 'Tarifa de abertura de crédito';
    case '23':
    case 'property_valuation_rate':
      return 'Tarifa de avaliação de bens';
    case 'iof_value':
      return 'IOF';
    case 'spf':
      return 'Seguro de proteção financeira';
    case 'spf_and_personal':
      return 'SPF + Seguro de acidentes pessoais';
    case 'spf_and_warranty':
      return 'SPF + Garantia';
    case 'spf_and_assistance':
      return 'SPF + Serviço de assistência';
    case 'cap':
      return 'Título de capitalização';
    case 'bem':
      return 'Seguro do bem';
    case 'personal_insurance':
      return 'Seguro de acidentes pessoais';
    case 'gravame':
      return 'Gravame';
    case 'accessory':
      return 'Acessório';
    case 'warranty':
      return 'Garantia';
    case 'maintenance':
      return 'Serviço de manutenção';
    case 'assistance':
      return 'Serviço de assistência';
    case 'customs_agent':
      return 'Despachante';
    case 'documentation':
      return 'Documentação';
    case 'tc':
      return 'Tarifa de cadastro';
    default:
      return description(expense);
  }
}

export const SPF = codes({}, 'spf');
export const SPF_SAP = codes({}, 'spf_and_personal');
export const SPF_WARRANTY = codes({}, 'spf_and_warranty');
export const SPF_ASSISTANCE = codes({}, 'spf_and_assistance');

export const CAP = codes({}, 'cap');
export const BEM = codes({}, 'bem');
export const SAP = codes({}, 'personal_insurance');

export default function identify(expense = {}, custom = true) {
  if (custom && expense.bank_name) {
    return expensize(expense.bank_name);
  }

  if (expense.credere_type) {
    return codes(expense, expense.credere_type);
  }

  if (expense.payload && expense.payload.credere_type) {
    return codes(expense, expense.payload.credere_type);
  }

  return codes(expense, expense.type);
}
